import { __read } from "tslib";
// To enforce the keys to always contain all keys of the type (TS)
var TEMP_ROOT = {
    id: null,
    className: null,
    style: null,
};
var ROOT_KEYS = Object.keys(TEMP_ROOT);
// To enforce the keys to always contain all keys of the type (TS)
var TEMP_INPUT = {
    disabled: null,
    readOnly: null,
    required: null,
};
var INPUT_KEYS = Object.keys(TEMP_INPUT);
// To enforce the keys to always contain all keys of the type (TS)
var TEMP_BASE = {
    size: null,
    inputProps: null,
    error: null,
    warning: null,
    success: null,
    withFeedbackIcon: null,
};
var BASE_KEYS = Object.keys(TEMP_BASE);
export function extractBaseInputComponentProps(props) {
    return Object.entries(props).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        var obj;
        if (ROOT_KEYS.includes(key)) {
            obj = acc.rootElementAttributes;
        }
        else if (BASE_KEYS.includes(key)) {
            obj = acc.baseInputComponentProps;
        }
        else if (INPUT_KEYS.includes(key)) {
            obj = acc.baseHtmlInputAttributes;
        }
        else {
            obj = acc.restProps;
        }
        obj[key] = val;
        return acc;
    }, {
        rootElementAttributes: {},
        baseInputComponentProps: {},
        baseHtmlInputAttributes: {},
        restProps: {},
    });
}
//# sourceMappingURL=extractBaseInputComponentProps.js.map